// extracted by mini-css-extract-plugin
export var active = "_de-c";
export var compactArrow = "_de-5";
export var container = "_de-0";
export var dot = "_de-b";
export var dotContainer = "_de-a";
export var hoverArrowButton = "_de-7";
export var hoverArrowContainer = "_de-6";
export var leftHoverArrowContainer = "_de-8 _de-6";
export var rightHoverArrowContainer = "_de-9 _de-6";
export var slide = "_de-4";
export var sliderContainer = "_de-1";
export var sliderContainerVisibleOverflow = "_de-2";
export var sliderOverflow = "_de-3";
export var vignetteBoth = "_de-f";
export var vignetteLeft = "_de-e";
export var vignetteRight = "_de-d";